import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dbdf961"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Staff To / Forecast Census", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "panleBody scrollBar" }
const _hoisted_8 = {
  id: "StaffToForecast",
  class: "container",
  style: {"width":"inherit"}
}
const _hoisted_9 = { id: "census-header" }
const _hoisted_10 = { class: "card shadow-sm mb-3 bg-white rounded" }
const _hoisted_11 = { class: "card-body position-relative" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-7 txtLeft" }
const _hoisted_14 = { class: "card-title mb-2" }
const _hoisted_15 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_16 = { class: "font-weight-bold" }
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = { class: "col text-end" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "PCS", -1))
const _hoisted_21 = { class: "pcstotalcensus" }
const _hoisted_22 = { class: "digits" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { class: "pcsrating" }
const _hoisted_25 = { class: "digits" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "pcsrangename" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = { class: "col-sm-3 text-end" }
const _hoisted_30 = { class: "digits" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = { class: "digits" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "digits" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Volume Level", -1))
const _hoisted_37 = { class: "digits" }
const _hoisted_38 = { class: "digits" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col text-end" }
const _hoisted_41 = { class: "card shadow-sm mb-3 bg-white rounded content" }
const _hoisted_42 = {
  class: "card-body position-relative",
  style: {"overflow":"auto"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "census-control-alerts my-3" }, null, -1))
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Forecast", -1))
const _hoisted_48 = { class: "col" }
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Actual Census", -1))
const _hoisted_51 = { class: "col" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Staff To", -1))
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "PCS", -1))
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col txtLeft" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "font-weight-bold" }, "Patient Classification Levels:", -1))
const _hoisted_60 = { class: "row" }
const _hoisted_61 = {
  "data-role": "listview",
  class: "col form-inline form-pcs"
}
const _hoisted_62 = { class: "font-weight-bold" }
const _hoisted_63 = { class: "font-weight-bold" }
const _hoisted_64 = { class: "col-md-8" }
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Notes", -1))
const _hoisted_67 = { id: "census-notes-container" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_70 = { class: "col-md-8" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = { class: "text-end" }
const _hoisted_73 = {
  key: 0,
  id: "staffingForecastLoadingDiv",
  class: "loadingDiv1",
  style: {"padding":"5px"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "actionable-content-loading",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fa-2x" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin" })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Saving...")
  ])
], -1))
const _hoisted_75 = [
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_AddViewNote = _resolveComponent("AddViewNote")!
  const _component_neu_button = _resolveComponent("neu-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.facilityName), 1),
                    _createElementVNode("h6", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.serviceLineName), 1),
                      _createTextVNode(" > "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.departmentName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['far', 'calendar'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.startDate), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['far', 'clock'],
                        size: "sm",
                        class: "mr-1"
                      }),
                      _createTextVNode(),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.startTime), 1),
                      _createTextVNode(" - "),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.endTime), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("div", null, [
                      _hoisted_20,
                      _createElementVNode("span", _hoisted_21, [
                        _createTextVNode("Count: "),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.pcsTotalCensus != null ? _ctx.pcsTotalCensus: '00'), 1)
                      ]),
                      _hoisted_23,
                      _createElementVNode("span", _hoisted_24, [
                        _createTextVNode("Rating: "),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.pcsRating != null ? _ctx.pcsRating: '00'), 1)
                      ]),
                      _hoisted_26,
                      _createElementVNode("span", _hoisted_27, [
                        _createTextVNode("Level: "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.pcsRangeName), 1)
                      ]),
                      _hoisted_28
                    ], 512), [
                      [_vShow, _ctx.pcsEnabled]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("h6", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.statDescription), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["staffto", [_ctx.isHightlightStaffTo ? 'census-highlight' : '']])
                    }, [
                      _createTextVNode("Staff To: "),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.staffTo != null ? _ctx.staffTo: '00'), 1)
                    ], 2),
                    _hoisted_31,
                    _createElementVNode("span", {
                      class: _normalizeClass(["actual", [_ctx.isHightlightActualCensus ? 'census-highlight' : '']])
                    }, [
                      _createTextVNode("Actual: "),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.actualCensus != null ? _ctx.actualCensus: '00'), 1)
                    ], 2),
                    _hoisted_33,
                    _createElementVNode("span", {
                      class: _normalizeClass(["forecast", [_ctx.isHightlightForecastCensus ? 'census-highlight' : '']])
                    }, [
                      _createTextVNode("Forecast: "),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.forecastCensus != null ? _ctx.forecastCensus: '00'), 1)
                    ], 2),
                    _hoisted_35,
                    _hoisted_36,
                    _createTextVNode(": "),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.censusLow), 1),
                    _createTextVNode("-"),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.censusPeak), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", null, [
                      _createTextVNode("Last Census Update: "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.lastCensusUpdateStartDateTime), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode(_component_neu_input, {
                        name: "forecastCensus",
                        readonly: "",
                        disabled: "",
                        modelValue: _ctx.forecastCensus,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.forecastCensus) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode(_component_neu_input, {
                        name: "actualCensus",
                        readonly: "",
                        disabled: "",
                        modelValue: _ctx.actualCensus,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actualCensus) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_neu_input, {
                        name: "staffTo",
                        modelValue: _ctx.staffTo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.staffTo) = $event)),
                        inputmode: "numeric",
                        type: "number",
                        max: 999,
                        min: 0,
                        disabled: _ctx.isDisable,
                        onKeyup: _ctx.validateStaffTo,
                        onChange: _ctx.onChangeStaffTo
                      }, null, 8, ["modelValue", "disabled", "onKeyup", "onChange"])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_neu_input, {
                        name: "pcsTotalCensus",
                        readonly: "",
                        disabled: "",
                        modelValue: _ctx.pcsTotalCensus,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pcsTotalCensus) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.pcsEnabled]
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("div", null, [
                        _hoisted_59,
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pcsLevels, (pcslvl) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: pcslvl,
                                class: "form-group mb-0"
                              }, [
                                _createElementVNode("label", _hoisted_62, _toDisplayString(pcslvl.Level), 1),
                                _createVNode(_component_neu_input, {
                                  name: "Census",
                                  modelValue: pcslvl.Census,
                                  "onUpdate:modelValue": ($event: any) => ((pcslvl.Census) = $event),
                                  inputmode: "numeric",
                                  type: "number",
                                  max: 999,
                                  min: 0,
                                  class: "pcsLevelTxt",
                                  onChange: _ctx.pcsOnChange
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createTextVNode("Avg. PCS Rating: "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.pcsNewRating), 1)
                        ])
                      ], 512), [
                        [_vShow, _ctx.pcsEnabled]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_AddViewNote)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_neu_button, {
                          type: "button",
                          fill: "raised",
                          id: "btnClose",
                          onClick: _ctx.close,
                          class: "close-census-button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'sign-out-alt'],
                              size: "sm",
                              class: "mr-2"
                            }),
                            _createTextVNode(" Close ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_neu_button, {
                          type: "button",
                          fill: "raised",
                          id: "btnSaveCensus",
                          onClick: _ctx.btnSaveCensus_OnClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'save'],
                              size: "sm",
                              class: "mr-2"
                            }),
                            _createTextVNode(" Save Changes ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.isShowStaffingForecastLoadingDiv)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}